import { render, staticRenderFns } from "./DialogOpenVip.vue?vue&type=template&id=396e3243&scoped=true&"
import script from "./DialogOpenVip.vue?vue&type=script&lang=js&"
export * from "./DialogOpenVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e3243",
  null
  
)

export default component.exports